<template>
  <div id="head-comp">
   <div class="nav-row">
     <a href="./index.html">
       <img src="../common/img/logo.png" alt="">
     </a>
     <div class="nav-wrap">
       <a :href="item.link" v-for="(item,ind) in navArr" :key="ind" :class="{'active':oriHref.indexOf(item.key)>-1 || ((oriHref.indexOf('.html') === -1) && item.key==='index')}">{{ item.name }}</a>
       <a href="javascript:void(0)" class="app-nav">APP下载
         <img src="../common/img/head-app.png" alt="">
       </a>
     </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'commonHead',
  data(){
    return{
      oriHref: window.location.href,
      navArr:[
        {
          name:'首页',
          link:'./index.html',
          key: 'index',
        },
        {
          name:'动态',
          link:'./Dynamic.html',
          key: 'Dynamic'
        },
        {
          name:'课堂',
          link:'./ClassRoom.html',
          key: 'ClassRoom'
        },
        {
          name:'互动',
          link:'./QA.html',
          key: 'QA'
        },
        {
          name:'模拟',
          link:'./Simulation.html',
          key: 'Simulation'
        }
      ]
    }
  },
  mounted() {
    
  },
  methods:{
    
  }
}
</script>

<style lang="less">
@import '../common/global.less';
#head-comp{
  background-color:#fff;
  position: sticky;
  top:0;
  left:0;
  z-index:90;
  border-bottom: 1px solid #ccc;
  height:80px;
  .nav-row{
    margin:0 auto;
    height:100%;
    display: flex;
    justify-content: space-between;
    color:#010101;
    align-items: center;
    width:1200px;
    .nav-wrap{
      display: flex;
      justify-content: space-between;
      a{
        color:#010101;
        text-decoration: none;
        text-align: center;
        padding:8px 0;
        flex:1;
        font-size:16px;
        transition-property: color ,background-color, border-bottom-color;
        transition-duration:.6s;
        width:94px;
        height:80px;
        border-bottom: 3px solid transparent;
        &:hover{
          background-color: rgba(39, 105, 228, 0.1);
          border-bottom-color:#286AE4;
          color:#286AE4;
          font-weight: bold;
        }
        &.active{
          background-color: rgba(39, 105, 228, 0.1);
          border-bottom-color:#286AE4;
          color:#286AE4;
          font-weight: bold;
        }
        .flex-center-layout();
        &.app-nav{
          position: relative;
          &:hover{
            opacity: 1;
            img{
              display: block;
            }
          }
          img{
            position: absolute;
            display: none;
            width:140px;
            bottom:-110px;
            left:50%;
            margin-left:-70px;
          }
        }
      }
    }
  }
}

</style>

